var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"notify"}},[(_vm.show)?_c('div',{class:['notify', 'box-shadow', _vm.type]},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.options.text))]})],2):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }